import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-account",
  "use": "icon-account-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-account\"><path d=\"M565 518.9v-28.2C613.5 470 647.5 422 647.5 366c0-74.8-60.6-135.5-135.5-135.5S376.5 291.2 376.5 366c0 56 34 104 82.4 124.6v28.2c-75.1 15.3-132.1 82.1-132.1 161.6v84.7c0 15.6 12.7 28.2 28.2 28.2h313.8c15.6 0 28.2-12.7 28.2-28.2v-84.7c0.2-79.4-56.8-146.1-132-161.5z\" p-id=\"10835\" /><path d=\"M512 0C229.7 0 0 229.7 0 512s229.7 512 512 512 512-229.7 512-512S794.3 0 512 0z m0 951.3c-242.2 0-439.3-197-439.3-439.3S269.8 72.7 512 72.7s439.3 197 439.3 439.3S754.2 951.3 512 951.3z\" p-id=\"10836\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/account.svg
// module id = lNpt
// module chunks = 42